<script setup lang="ts">
import type { EventResponse, RegistrationAttendeeResponse } from '@@/types/api';

defineProps<{
  event: EventResponse;
  attendance: RegistrationAttendeeResponse;
}>();

function formatClaimedDate(iso: string | null) {
  if (!iso) return null;
  return new Date(iso).toLocaleDateString();
}
</script>

<template>
  <div class="claimed-attendee-view">
    <div class="d-flex align-center mb-3">
      <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
      <span class="text-subtitle-1 font-weight-bold">You're attending</span>
    </div>

    <p class="text-body-2 text-medium-emphasis mb-4">
      You've claimed a seat for this event. The registration is managed by the
      person who invited you.
    </p>

    <div v-if="attendance.claimed_at" class="text-body-2 text-medium-emphasis">
      <v-icon size="small" class="mr-1">mdi-calendar-check</v-icon>
      Seat claimed on {{ formatClaimedDate(attendance.claimed_at) }}
    </div>
  </div>
</template>
